// extracted by mini-css-extract-plugin
export var name = "styles-module--name--ff9c2";
export var starIcon = "styles-module--starIcon--b24da";
export var stars = "styles-module--stars--6f26e";
export var text = "styles-module--text--086ae";